import React, { Fragment, useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { addQueryToUrl } from 'dpl/util/queryString';
import { BreedSearchResultPropTypes } from 'dpl/shared/utils/customPropTypes';
import SearchNoResults from 'dpl/components/Search/SearchNoResults';

import {
  BREED_PROFILES,
  BREED_TYPES,
  ORDERED_BREED_TYPES,
  getGroupedBreedsV2
} from '../util';
import BreedSearchResultItemV2 from './BreedSearchResultItemV2';

export default function BreedSearchResultsList({
  analytics,
  query,
  breeds,
  breedType,
  inDropdown,
  onSelectItem,
  maxHeight
}) {
  const selectedType = breedType || ORDERED_BREED_TYPES[0];

  const filteredBreeds = useMemo(() => {
    const groupedBreeds = getGroupedBreedsV2(breeds, query);
    return groupedBreeds[selectedType] || [];
  }, [breeds, query, selectedType]);

  return (
    <div
      className={classnames('BreedSearchResultsList overflow-y-auto', {
        ph2: inDropdown
      })}
      style={{ maxHeight }}
    >
      {filteredBreeds.length === 0 ? (
        <SearchNoResults
          className={classnames({
            'ph5 pv3': inDropdown,
            'ph5 pv2': !inDropdown
          })}
          query={query}
        />
      ) : (
        <Fragment>
          {filteredBreeds.map(breed => {
            const { cover_photo_url: coverPhotoUrl, name, url } = breed;

            let standardUrl = url;

            if (analytics?.origin_view) {
              standardUrl = addQueryToUrl(
                {
                  origin_view: analytics.origin_view,
                  origin_view_feature: analytics.origin_view_feature
                },
                url
              );
            }

            return [
              <div key={standardUrl}>
                <BreedSearchResultItemV2
                  coverPhotoUrl={coverPhotoUrl}
                  inDropdown={inDropdown}
                  name={name}
                  url={standardUrl}
                  onClick={
                    onSelectItem &&
                    (e => {
                      e.preventDefault();
                      onSelectItem(breed);
                    })
                  }
                />
              </div>
            ];
          })}
        </Fragment>
      )}
    </div>
  );
}

BreedSearchResultsList.propTypes = {
  analytics: PropTypes.shape({
    origin_view: PropTypes.string,
    origin_view_feature: PropTypes.string
  }),
  query: PropTypes.string,
  breeds: PropTypes.arrayOf(PropTypes.shape(BreedSearchResultPropTypes))
    .isRequired,
  inDropdown: PropTypes.bool,
  breedType: PropTypes.oneOf([BREED_TYPES.ALL, BREED_PROFILES]),
  onSelectItem: PropTypes.func,
  maxHeight: PropTypes.string
};

BreedSearchResultsList.defaultProps = {
  analytics: {},
  query: '',
  breedType: null,
  inDropdown: false,
  onSelectItem: undefined,
  maxHeight: null
};
